import {request} from "../../base/HTTP";

export async function getAuditTrails(data) {
    return await request('/api/auditTrail/search', data);
}

